/* eslint-disable */ 
import {useState } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast } from '@chakra-ui/react'; 
import { TbFileInvoice } from 'react-icons/tb';

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';
import Actions from 'views/privado/servicesPostsales/estadosCuenta/components/Actions';

import service from 'services/estadosCuentaService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
	existsInvoice: Boolean;
	fechaString: string ;
	numero: string;
	tipo: string;
	expediente: string;
	venceString: string;
	diasVencido: string;
	montoString: string;
	haberString: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION } from "const/CommonConst";

export default function DataTable() {
	const textColor = useColorModeValue("navy.700", "white");
  const brandColor = useColorModeValue("brand.500", "brand.400");
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

  const toast = useToast()

  const [tableData, setTableData] = useState([]);

  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(false);
  const [showProgressSearch, setShowProgressSearch] = useState(false);
  const [showProgressExport, setShowProgressExport] = useState(false);
  

  const fetchData = async (cliente:string, tipoDocumento:string, compañia:string) => {
    return await service.getTabla(cliente, tipoDocumento, compañia);
  };

  const onChangeFilters = async (selected:any) => {
	try {
	setShowEmptyState(false);
	setDisabledActions(true);
	setShowProgressSearch(true);
	setTableData(await fetchData(selected.cliente, selected.tipoDocumento, selected.compañia));
}
  finally{
	setDisabledActions(false);
	setShowProgressSearch(false);
  }
  };

  const onExportData = async (selected:any) => {
	try {
	setDisabledActions(true);
	setShowProgressExport(true);
	await service.getExcel(selected.cliente, selected.tipoDocumento, selected.compañia);
	toast({
		title: EXPORT_TITLE,
		description: EXPORT_DESCRIPTION,
		status: 'success',
		duration: 9000,
		isClosable: true,
	  });
	}
	  finally{
		setDisabledActions(false);
		setShowProgressExport(false);
	  }
  };

    const columnHelper = createColumnHelper<RowObj>();
 	const columns = [
		// columnHelper.accessor('existsInvoice', {
		// 	id: 'existsInvoice',
		// 	header: () => (
		// 		<Text
		// 			justifyContent='space-between'
		// 			align='left'
		// 			fontSize={{ sm: '10px', lg: '12px' }}
		// 			color='gray.400'>
		// 			FACTURA
		// 		</Text>
		// 	),
		// 	cell: (info: any) => (
        // <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
        //     {info.getValue() ? <Icon as={TbFileInvoice} width='20px' height='20px' color={brandColor} /> : ''}
        // </Text>
		// 	)
		// }), 
		columnHelper.accessor('fechaString', {
			id: 'fechaString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					FECHA
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('numero', {
			id: 'numero',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					NRO. DOCUMENTO
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
          {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('tipo', {
			id: 'tipo',
			header: () => (
				<Text
					justifyContent='space-between'
					align='center'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					TIPO DOCUMENTO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='center' fontSize='md' fontWeight='500'>
				{info.getValue()}
			  </Text>
			)
		}),
		columnHelper.accessor('expediente', {
			id: 'expediente',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE
				</Text>
			),
			cell: (info) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('venceString', {
			id: 'venceString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        F/VENCIMIENTO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('diasVencido', {
			id: 'diasVencido',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        DÍAS TRANSCURRIDOS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('montoString', {
			id: 'montoString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        DEBE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('haberString', {
			id: 'haberString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HABER
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		})   
	];
	
  return ( 
    <CommonDatatable
    columnsDefinition={columns}
    tableData={tableData}
	showEmptyState={showEmptyState}
	isLoading={disabledActions}
    actionContent={    
        <Actions onChange={onChangeFilters} 
				 onExport={onExportData} 
				 disabledActions={disabledActions} 
				 showProgressExport={showProgressExport} 
				 showProgressSearch={showProgressSearch} /> }

		footerContent={
			tableData.length > 0 ?
			<Flex direction='column' bg={boxBg} p='16px 20px' borderRadius='14px' mt='15px' ml='auto'>
				<Text fontSize='sm' fontWeight='700' color={textColor}>
				Su saldo vencido a la fecha es de:
				</Text>
				<Text fontSize='sm' fontWeight='500' color='secondaryGray.600' textAlign='right'>
				{tableData[0].saldoGlobal} Bs.
				</Text>
			</Flex>
			:  <></>
		}
      />        
  )
} 
